<template>
    <div>
        <b-nav pills>
            <b-nav-item
                        :to="{ name: 'user_permission-model'}"
                        exact
                        exact-active-class="active"
                >
                    По сущностям
                </b-nav-item>
                <b-nav-item
                        :to="{ name: 'user_permission-object'}"
                        exact
                        exact-active-class="active"
                >
                    По обьектам
                </b-nav-item>
            </b-nav>
        <router-view></router-view>
    </div>
</template>

<script>
    import {BNav, BNavItem } from 'bootstrap-vue'

    export default {
        components: {
            BNav, BNavItem,
        },
    }
</script>
